(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/helper-functions.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/helper-functions.js');
"use strict";


const getDrawFromCoupon = coupon => {
  if (!coupon.drawNumber) {
    return null;
  }
  const draws = svs.challenge.store.getState().draws;
  for (let i = 0; i < draws.length; ++i) {
    if (draws[i].drawNumber === coupon.drawNumber) {
      return draws[i];
    }
  }
  return null;
};
function getDrawByDrawNumber(drawNumber, state) {
  return _.findWhere(state.draws, {
    drawNumber
  });
}

function correctDrawUrl(draw) {
  let eventNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  let bigStatTab = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  let precedingSlash = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  let path = "".concat(precedingSlash ? '/' : '', "spela/").concat(draw.drawNumber);

  let validatedEventNumber = eventNumber !== null && eventNumber !== void 0 ? eventNumber : !svs.core.detect.formfactor.mobile() ? 1 : undefined;
  validatedEventNumber = validatedEventNumber > 0 && validatedEventNumber <= draw.drawEvents.length ? validatedEventNumber : undefined;
  if (validatedEventNumber) {
    var _draw$drawEvents$find;
    const eventDescription = (_draw$drawEvents$find = draw.drawEvents.find(drawEvent => drawEvent.eventNumber === validatedEventNumber)) === null || _draw$drawEvents$find === void 0 ? void 0 : _draw$drawEvents$find.eventDescription;
    path += "/".concat(validatedEventNumber, "-").concat(svs.utils.url.encode(eventDescription));
    if (bigStatTab) {
      path += "/".concat(svs.utils.url.encode(bigStatTab));
    }
  }
  return path;
}
function isAccountSelectorLoaded() {
  return svs.components && svs.components.marketplace && svs.components.marketplace.accountSelector;
}
function initiateAccountSelector(drawNumber, productId) {
  if (isAccountSelectorLoaded()) {
    svs.components.marketplace.accountSelector.helpers.observer.notify({
      drawNumber,
      productId
    });
    svs.components.marketplace.accountSelector.helpers.fetchGames({
      drawNumber,
      productId
    });
  }
}
function getMarketplaceAccount() {
  const {
    marketplace
  } = svs.components;
  if (marketplace && marketplace.accountSelector) {
    return marketplace.accountSelector.helpers.getCurrentAccount();
  }
  return undefined;
}
const getCouponByDrawNumber = (state, drawNumber) => state.coupons.find(coupon => coupon.drawNumber === drawNumber);
svs.challenge.helpers = {
  correctDrawUrl,
  getCouponByDrawNumber,
  getDrawByDrawNumber,
  getDrawFromCoupon,
  getMarketplaceAccount,
  initiateAccountSelector,
  isAccountSelectorLoaded
};

 })(window);